import { useTranslation } from 'react-i18next';
import { notify } from '../utils/notification';

export const useClipboard = () => {
  const { t } = useTranslation();
  const copyToClipboard = (copy: string, onSuccess?: () => void) => {
    navigator.clipboard.writeText(copy).then(() => {
      notify.positive({ message: t('copiedToClipboard'), duration: 500 });
      onSuccess?.();
    });
  };
  const copyRichTextToClipboard = (copy: string, onSuccess?: () => void) => {
    const blob = new Blob([copy], { type: 'text/html' });
    const clipboardItem = new ClipboardItem({ 'text/html': blob });

    navigator.clipboard.write([clipboardItem]).then(() => {
      notify.positive({ message: t('copiedToClipboard'), duration: 500 });
      onSuccess?.();
    });
  };

  return {
    copyToClipboard,
    copyRichTextToClipboard,
  };
};
